import { configureStore } from '@reduxjs/toolkit'
import generalReducer from './slices/generalSlice'
import { Api } from './reduxToolkitQuery'
import { setupListeners } from '@reduxjs/toolkit/query'

export const store = configureStore({
  reducer: {
    general: generalReducer,
    // Add the generated reducer as a specific top-level slice
    [Api.reducerPath]: Api.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(Api.middleware),
})

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)
